import DateNav from '../vue/DateNav.vue'
import { createApp } from "vue";

export function mountDateNavComponent(mountPoint, props) {
  const app = createApp(DateNav, props);
  app.mount(mountPoint);
}